import React from "react"
import { Box } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import PropTypes from "prop-types"
import theme from "../../../../theme/theme"
import {formatDateString} from "../../../../../utils/format-date"

const InfoItem = ({ label, value }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
                variant="contraHeading"
                sx={{ color: theme.palette.primary.white70 }}
            >
                {label}
            </Typography>
            <Typography variant="textBody" color="common.white">
                {value}
            </Typography>
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export const BoxDataEmission = ({ characterData }) => {
    const formatDate = (date) => formatDateString(date, "-")

    const formatValue = (value) => {
        if (!value) return "-"
        try {
            return new Intl.NumberFormat("pt-BR").format(value)
        } catch {
            return "-"
        }
    }
    return (
        <Box display="flex" gap={3} flexDirection="column">
            <Typography variant="h3" color="common.white">
                Dados da emissão
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: { lg: "row", xxxs: "column" },
                    gap: 0.125,
                }}
            >
                <Box
                    p={3}
                    sx={{
                        background:
                            "linear-gradient(146.22deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                    }}
                >
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                        }}
                    >
                        <Grid item xxxs={2} md={3} lg={12} sm={4}>
                            <InfoItem
                                label="Cetip"
                                value={characterData?.CETIP ?? "-"}
                            />
                        </Grid>

                        <Grid item xxxs={2} md={3} lg={12} sm={4}>
                            <InfoItem
                                label="ISIN"
                                value={characterData?.ISIN ?? "-"}
                            />
                        </Grid>

                        <Grid item xxxs={1} md lg={6} sm={1}>
                            <InfoItem
                                label="Série"
                                value={characterData?.Serie ?? "-"}
                            />
                        </Grid>
                        <Grid item xxxs={1} md lg={6} sm={1}>
                            <InfoItem
                                label="Emissão"
                                value={characterData?.Emissao ?? "-"}
                            />
                        </Grid>
                        <Grid item xxxs={1} md lg={6} sm={1}>
                            <InfoItem
                                label="Tipo Ativo"
                                value={characterData?.TipoAtivo ?? "-"}
                            />
                        </Grid>
                        <Grid item xxxs={1} md lg={6} sm={1}>
                            <InfoItem
                                label="Fluxo Base"
                                value={characterData?.FluxoBase ?? "-"}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={0.125}
                    width="100%"
                >
                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, md: 0 },
                            }}
                        >
                            <InfoItem
                                label="Data Emissão"
                                value={formatDate(characterData?.DataEmissao)}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Data Vencimento"
                                value={formatDate(
                                    characterData?.DataVencimento
                                )}
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, md: 0 },
                            }}
                        >
                            <InfoItem
                                label="Data 1ª Integralização"
                                value={formatDate(
                                    characterData?.DataPrimeiraIntegralizacao
                                )}
                            />
                        </Grid>

                        <Grid item xxxs={2} lg>
                            <InfoItem
                                label="Data Resgate antecipado"
                                value={formatDate(
                                    characterData?.DataResgateAntecipado
                                )}
                            />
                        </Grid>

                        <Grid item xxxs={2} lg>
                            <InfoItem
                                label="Lei 12.431"
                                value={characterData?.Lei12431 ?? "-"}
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, md: 0 },
                            }}
                        >
                            <InfoItem
                                label="Pu Emissão"
                                value={formatValue(characterData?.PU_Emissao)}
                            />
                        </Grid>
                        <Grid
                            item
                            md={3}
                            xs
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Quantidade Emitida"
                                value={formatValue(
                                    characterData?.QuantidadeEmitida
                                )}
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Volume financeiro"
                                value={formatValue(
                                    characterData?.VolumeFinanceiro
                                )}
                            />
                        </Grid>
                        <Grid item xxxs={2} md={3} lg>
                            <InfoItem
                                label="Distribuição"
                                value={characterData?.Distribuicao ?? "-"}
                            />
                        </Grid>
                        <Grid item xs />
                    </Grid>

                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={1}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, md: 0 },
                            }}
                        >
                            <InfoItem
                                label="Indicador"
                                value={characterData?.Indicador ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Taxa Accrual"
                                value={formatValue(characterData?.TaxaAccrual)}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Duration Emissão"
                                value={formatValue(
                                    characterData?.DurationEmissao
                                )}
                            />
                        </Grid>
                        <Grid item xxxs={2} md={3} lg>
                            <InfoItem
                                label="Spread Emissão"
                                value={characterData?.SpreadEmissao ?? "-"}
                            />
                        </Grid>
                        <Grid item xxxs={2} lg />
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}
BoxDataEmission.propTypes = {
    characterData: PropTypes.shape({
        ISIN: PropTypes.string,
        CETIP: PropTypes.string,
        Serie: PropTypes.string,
        Emissao: PropTypes.number,
        TipoAtivo: PropTypes.string,
        FluxoBase: PropTypes.number,
        DataEmissao: PropTypes.string,
        DataVencimento: PropTypes.string,
        DataPrimeiraIntegralizacao: PropTypes.string,
        DataResgateAntecipado: PropTypes.string,
        Lei12431: PropTypes.string,
        PU_Emissao: PropTypes.number,
        QuantidadeEmitida: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        VolumeFinanceiro: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        Distribuicao: PropTypes.string,
        Indicador: PropTypes.string,
        TaxaAccrual: PropTypes.number,
        DurationEmissao: PropTypes.number,
        SpreadEmissao: PropTypes.number,
    }),
}
